import { FullScreenDialog } from '@/shared/ui';
import { AgreementContent } from '@/entities/agreement';
import type { AgreementCode } from '@/shared/data-types';
import { UI_TEXT } from '@/shared/languages';

/** code 별 정적 라벨 — 로드 전에도 즉시 쓸 수 있는 a11y 제목. */
const AGREEMENT_TITLE: Record<AgreementCode, string> = {
  terms: UI_TEXT.AGREEMENT_TERMS_TITLE,
  privacy: UI_TEXT.AGREEMENT_PRIVACY_TITLE,
  refund: UI_TEXT.AGREEMENT_REFUND_TITLE,
};

export interface AgreementModalProps {
  code: AgreementCode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * 약관 원문 모달 — shared `FullScreenDialog` 에 `AgreementContent`(entity-UI)를 얹은 합성.
 * 진입점 분리(page=URL/심사, modal=in-app footer·동의폼 원문보기)는 상위가 담당.
 * 가시 제목은 `AgreementContent` 의 h1(BE name) — FullScreenDialog title 은 a11y 용 정적 라벨.
 */
export function AgreementModal({ code, open, onOpenChange }: AgreementModalProps) {
  return (
    <FullScreenDialog open={open} onOpenChange={onOpenChange} title={AGREEMENT_TITLE[code]}>
      <AgreementContent code={code} />
    </FullScreenDialog>
  );
}
